import BenfitStyle from '@/styles/components/careers/add-section/_index.module.scss';

export function BenfitSection({formik, sidebar_section, customizeCareerAction}){
  return(
    <div className = {`${BenfitStyle.Benefit}`}>
      <label className = {`${BenfitStyle.Benefit__Title}`}>Benefit</label>

      {/************* First Option ***************/}

      <div className = {`${BenfitStyle.Benefit__FirstOption}`} onClick={(event) => {
            customizeCareerAction.addSection(formik, 'benefit', 'six_cards')
          }}>
        <div className = {`${BenfitStyle.Benefit__Content}`}>
          <div className = {`${BenfitStyle.Benefit__SubTitle}`}>
            <h3>{sidebar_section.benefit.title}</h3>
          </div>
          <div className = {`${BenfitStyle.Benefit__Cards}`}>
            <div className = {`${BenfitStyle.Benefit__Card}`}>
              <div className = {`${BenfitStyle.Benefit__Card__Icon}`}>
                <img src = '/images/pages/career/benefit/icons/fire--alarm.png'></img>
              </div>
              <div className = {`${BenfitStyle.Benefit__Card__Title}`}>
                <p>Delightful</p>
              </div>
              <div className = {`${BenfitStyle.Benefit__Card__Text}`}>
                <label>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec suscipit molestie nisl nec volutpat. Aenean facilisis. Lorem</label>
              </div>
            </div>
            <div className = {`${BenfitStyle.Benefit__Card}`}>
              <div className = {`${BenfitStyle.Benefit__Card__Icon}`}>
                <img src = '/images/pages/career/benefit/icons/apple.png'></img>
              </div>
              <div className = {`${BenfitStyle.Benefit__Card__Title}`}>
                <p>Wonderful</p>
              </div>
              <div className = {`${BenfitStyle.Benefit__Card__Text}`}>
                <label>Values help potential employees understand what the company stands for and whether it aligns with their personal values and career aspiration.</label>
              </div>
            </div>
            <div className = {`${BenfitStyle.Benefit__Card}`}>
              <div className = {`${BenfitStyle.Benefit__Card__Icon}`}>
                <img src = '/images/pages/career/benefit/icons/fire--alarm.png'></img>
              </div>
              <div className = {`${BenfitStyle.Benefit__Card__Title}`}>
                <p>Delightful</p>
              </div>
              <div className = {`${BenfitStyle.Benefit__Card__Text}`}>
                <label>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec suscipit molestie nisl nec volutpat. Aenean facilisis.</label>
              </div>
            </div>
            <div className = {`${BenfitStyle.Benefit__Card}`}>
              <div className = {`${BenfitStyle.Benefit__Card__Icon}`}>
                <img src = '/images/pages/career/benefit/icons/rock-on.png'></img>
              </div>
              <div className = {`${BenfitStyle.Benefit__Card__Title}`}>
                <p>Rock</p>
              </div>
              <div className = {`${BenfitStyle.Benefit__Card__Text}`}>
                <label>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec suscipit molestie nisl nec volutpat. Aenean facilisis.</label>
              </div>
            </div>
            <div className = {`${BenfitStyle.Benefit__Card}`}>
              <div className = {`${BenfitStyle.Benefit__Card__Icon}`}>
                <img src = '/images/pages/career/benefit/icons/dummy-icon.svg'></img>
              </div>
              <div className = {`${BenfitStyle.Benefit__Card__Title}`}>
                <p className = {`${BenfitStyle.Benefit__AddTitleText}`}>Add title</p>
              </div>
              <div className = {`${BenfitStyle.Benefit__Card__Text}`}>
                <label className = {`${BenfitStyle.Benefit__AddDescriptionText}`}>Add description</label>
              </div>
            </div>
            <div className = {`${BenfitStyle.Benefit__Card}`}>
              <div className = {`${BenfitStyle.Benefit__Card__Icon}`}>
                <img src = '/images/pages/career/benefit/icons/dummy-icon.svg'></img>
              </div>
              <div className = {`${BenfitStyle.Benefit__Card__Title}`}>
                <p className = {`${BenfitStyle.Benefit__AddTitleText}`}>Add title</p>
              </div>
              <div className = {`${BenfitStyle.Benefit__Card__Text}`}>
                <label className = {`${BenfitStyle.Benefit__AddDescriptionText}`}>Add description</label>
              </div>
            </div>
          </div>
        </div>
       <div className = {`${BenfitStyle.Benefit__AddBtn} noAddbtn__Inreorder`}>
          <span>Add</span>
        </div>
      </div>
    </div>
  )
}